var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListTemplate',{attrs:{"fields":_vm.fields,"create-action":false,"update-action":_vm.isAdmin,"delete-action":false,"api-url":_vm.apiURL,"title":_vm.$route.meta.title}})}
var staticRenderFns = []

export { render, staticRenderFns }